export default {"src":"/_next/static/media/pressurecooker.83590b18.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};